import React from "react";
import { Form, FormGroup, Row } from "react-bootstrap";
import {
  DocuClipperBillingCycle,
  DocuClipperPlan,
  DocuClipperPricing,
  StripeSubscription,
} from "../../../../docuclipper/DocuclipperTypes";
import { getCurrencySymbol } from "./PlanSelector2";
type Props = {
  onSelected: (billingCycle: DocuClipperBillingCycle) => any;
  pricing: DocuClipperPricing;
  discountedPricing: DocuClipperPricing | null;
  selectedPlan: DocuClipperPlan;
  selectedBillingCycle: DocuClipperBillingCycle;
  subscription: StripeSubscription;
};
export const BillingCycleSelector: React.SFC<Props> = ({
  onSelected,
  pricing,
  discountedPricing,
  selectedPlan,
  selectedBillingCycle,
  subscription,
}) => {
  const getDiscounted = (originalPrice) => {
    if (!subscription || !subscription.coupon) {
      return originalPrice;
    }
    return Math.round((originalPrice * subscription.coupon.percent_off) / 100);
  };
  const monthlyAmount = Math.round(pricing[selectedPlan]["Monthly"].amount);
  const monthlyAmountDiscounted = discountedPricing
    ? Math.round(discountedPricing[selectedPlan]["Monthly"].amount)
    : monthlyAmount;

  const annualAmount = Math.floor(pricing[selectedPlan]["Annually"].amount);
  const annualAmountDiscounted = discountedPricing
    ? Math.floor(discountedPricing[selectedPlan]["Annually"].amount)
    : annualAmount;

  const monthlyAmountInAnnualPlan = Math.floor(annualAmount / 12);
  const monthlyAmountInAnnualPlanDiscounted = Math.floor(
    annualAmountDiscounted / 12
  );

  const currencySymbol = getCurrencySymbol(
    pricing[selectedPlan]["Annually"].currency
  );
  const annualLabel = `${currencySymbol}${monthlyAmountInAnnualPlanDiscounted} every month (${currencySymbol}${annualAmountDiscounted} now)`;
  const annualLabelEnterprise = `${currencySymbol}${monthlyAmountInAnnualPlanDiscounted} / month / user (${currencySymbol}${annualAmountDiscounted} now)`;

  const annualSavings =
    pricing[selectedPlan]["Annually"].annualSavings.toFixed(0);
  const annualSavingsDiscounted = getDiscounted(annualSavings);

  return (
    <FormGroup className="m-2">
      <FormGroup
        onClick={(e) => onSelected("Monthly")}
        style={{
          cursor: "pointer",
          backgroundColor:
            selectedBillingCycle === "Monthly" ? "lightblue	" : "white",
        }}
      >
        <div className="p-4">
          <Form.Check
            type="radio"
            value="Monthly"
            checked={selectedBillingCycle === "Monthly"}
            onChange={(e) => onSelected("Monthly")}
            label={
              <>
                {`${currencySymbol}${monthlyAmountDiscounted} ${
                  ["Starter", "Business", "Professional"].includes(selectedPlan)
                    ? "every month"
                    : " / month / user"
                }`}
              </>
            }
          />{" "}
        </div>
      </FormGroup>
      <FormGroup
        onClick={(e) => onSelected("Annually")}
        style={{
          cursor: "pointer",
          backgroundColor:
            selectedBillingCycle === "Annually" ? "lightblue	" : "white",
        }}
      >
        <Row className="p-4 justify-content-between mx-0">
          <div>
            <Form.Check
              type="radio"
              value="Annually"
              checked={selectedBillingCycle === "Annually"}
              onChange={(e) => onSelected("Annually")}
              label={
                annualLabel
                /*["Starter", "Professional", "Business"].includes(selectedPlan)
                  ? annualLabel
                  : annualLabelEnterprise*/
              }
            />
          </div>
          <div
            className="font-weight-bold text-danger"
            style={{ color: "green" }}
          >
            {`Save ${currencySymbol}${annualSavingsDiscounted} per year!`}
          </div>
        </Row>
      </FormGroup>
    </FormGroup>
  );
};
export default BillingCycleSelector;
